module.exports = __webpack_public_path__ + "img/user.6269fd08.png";